import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InsuranceCompanyGetService } from './insurance-company.service';

@NgModule({
  imports: [CommonModule],
  providers: [InsuranceCompanyGetService],
})
export class InsuranceCompanyModule {}
